import ENV from "config/Env";
import { backendQueryKey, localQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { Tyre } from "models";

export type IncompleteTyresResponse = {
  tyres: Tyre[];
  nb_items: number;
  nb_pages: number;
};

export type IncompleteTyresFilters = {
  page: number;
  page_size: number;
};

const component = "IncompleteTyresDashboard";

export const IncompleteTyresQueryKeys = {
  filters: localQueryKey<IncompleteTyresFilters>({ component, data: "filters" }),
  brands: permanentBackendQueryKey<string[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/tyres/brands/list" }),
  incompleteTyres: backendQueryKey<IncompleteTyresResponse>({ component, baseUrl: ENV.carBaseURL, endpoint: "/tyres/incomplete/list" }),
  searchCompleteTyres: backendQueryKey<Tyre[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/tyres/search" })
};
